// no itx for this file

import { ChannelType } from "../../models/ChannelType";
import SignalTypes from "../../models/SignalTypes";
import { NameListEntry } from "../NameEntryList";
import { ruleId } from "../ruleId";

export const buttonActions: Array<NameListEntry> = [
  /////////////////////////////////////////////////////////////////////////////////////
  //
  // Manufactor specific definitions
  //
  ////////////////////////////////////////////////////////////////////////////////
  // MDT
  {
    id: ruleId("Button-Actions-Ignored-mdt"),
    signalType: SignalTypes.Switch,
    functionNames: ["external button"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-0083"], // abb // busch jäger
  },
  // "m-0008" == Gira
  {
    manufacturers: ["m-0008"],
    id: ruleId("Button-Actions-Gira-1"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: [/temperature value/], // 2220 00 KNX närvarodetektor Mini Standard
    dpts: ["dpst-9-1"],
  },
  ////////////////////////////////////////////////////////////////////////////////
  // "m-0007" == Busch-Jaeger
  {
    manufacturers: ["m-0007"],
    id: ruleId("Button-Actions-Busch-1"),
    signalType: SignalTypes.Switch,
    functionNames: [/movement (master)/],
    dpts: ["dpst-1-1"],
  },

  //////////////////////////////////////////////////////////////////////////////////
  // "m-0085" == GVS

  {
    //    manufacturers: ["m-0085"], // GVS
    id: ruleId("Button-Actions-gvs-1"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: ["current setpoint adjustment"],
    excludeFunctionNames: ["status"],
    dpts: ["dpst-9-1"],
  },

  {
    id: ruleId("Button-Actions-gira-TargetShift-1"),
    signalType: SignalTypes.Temperature_TargetShift_9,
    functionNames: ["offset setpoint adjustment"],
    excludeFunctionNames: ["status"],
    dpts: ["dpst-9-2"],
  },

  {
    id: ruleId("Button-Actions-gira-2"),
    signalType: SignalTypes.Temperature_TargetShift_6,
    functionNames: ["offset setpoint adjustment"],
    excludeFunctionNames: ["status"],
    dpts: ["dpst-6-10"],
  },
  //////////////////////////////////////////////////////////////
  // Merten M-000C

  // jalusie
  {
    id: ruleId("Button-Actions-merten-jalousie1"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["louvres"],
    functionNames: ["open / close", "closed / open"], // 6711 99
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  {
    id: ruleId("Button-Actions-merten-jalousie1_2"),
    signalType: SignalTypes.SlatPosition,
    texts: ["slat position"], // 6171xx
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },

  {
    id: ruleId("Button-Actions-merten-jalousie1_3"),
    signalType: SignalTypes.BlindPosition,
    texts: ["blind position"], // 6171xx
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  {
    id: ruleId("Button-Actions-merten-jalousie2"),
    signalType: SignalTypes.BlindMove, // nicht richtig welcher signal type????
    texts: ["shutter"],
    functionNames: ["up / down", "down / up"], // 6711 99
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  {
    id: ruleId("Button-Actions-merten-jalousie2_2"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["stop/step"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  // dimming
  {
    id: ruleId("Button-Actions-merten-dimming"),
    signalType: SignalTypes.DimStep,
    texts: ["dimming"],
    dpts: ["dpst-3-1"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  // switch
  {
    id: ruleId("Button-Actions-merten-switch1"),
    signalType: SignalTypes.Switch,
    texts: ["switch"],
    functionNames: ["on / off"], // 6711 99
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },

  // heating
  {
    id: ruleId("Button-Actions-merten-heating1"),
    signalType: SignalTypes.Temperature_Current,
    texts: ["external temp"], // MEG6212-04xx
    dpts: ["@ 2 bytes"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  // scene
  {
    id: ruleId("Button-Actions-merten-Scene"),
    signalType: SignalTypes.Scene,
    functionNames: ["scene"], // MEG6212-04xx
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"], // Merten M-000C
  },
  //////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////
  // block the following definitions as action and forward them to status evaluation
  //
  {
    id: ruleId("Button-Actions-block-dpst-1-*"),
    signalType: SignalTypes.Unknown, /// Unkown becaus it may be an status signal

    texts: [
      "led", // led is "status-led" => status for MDT BE-xx
      "fault", //abb 6321/38-500
      "error", //abb SBC/U6.0.1
      "rain",
    ],
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9", "dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-block-dpst-1-*-b"),
    signalType: SignalTypes.Unknown, /// Unkown becaus it may be an status signal
    functionNames: ["rain"],
    dpts: ["dpst-1"],
  },

  {
    id: ruleId("Button-Actions-daynight-1"),
    signalType: SignalTypes.DayNight,

    texts: [/day.*night/],
    dpts: ["dpst-1"],
  },

  {
    id: ruleId("Button-Actions-daynight-2"),
    signalType: SignalTypes.DayNight,
    functionNames: [/day.*night/],
    dpts: ["dpst-1"],
  },

  ///////////////////////////////////////////////////////////////////////////////////

  /// ignore
  {
    id: ruleId("Button-Actions-Dummy1"),
    signalType: SignalTypes.Ignored,
    texts: ["dummy"], // mdt BE-TA55P2.01
    dpts: undefined,
  },

  {
    id: ruleId("Button-Actions-Dummy2"),
    signalType: SignalTypes.Ignored,
    functionNames: ["dummy"],
    dpts: undefined, // mdt BE-TA55P2.01
  },

  {
    id: ruleId("Button-Actions-ignore1"),
    signalType: SignalTypes.Ignored,
    texts: [
      "relais request",
      "presence",
      "button activation",
      "shift key", //abb 6320/30-..-500
      "fahrenheit", //abb 6321/38-500
      "commissioned", //abb 6321/38-500
      "master", // abb 6321/38-500
      "ringing", // abb 	H8236
      "call", // abb 	H8236
      "open door", // abb 	H8236
      "presence", //SCN-RTR60O.01
      "buttons activation",
      "in operation", // Video Start, GVS : CHTFB-3.0/6.x.yz
    ],
    excludeTexts: ["movement"], // abb 	CGD 006 132 R0342 (Präsenzmelder )
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-ignore1a"),
    signalType: SignalTypes.Ignored,
    functionNames: [
      "in operation", // Video Start, GVS : CHTFB-3.0/6.x.yz
    ],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-ignore2"),
    signalType: SignalTypes.Ignored,
    functionNames: ["exernal"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-ignore3"),
    signalType: SignalTypes.Ignored,
    functionNames: ["operation"],
    dpts: ["dpst-1-11"],
  },
  {
    id: ruleId("Button-Actions-ignore4"),
    signalType: SignalTypes.Ignored,
    functionNames: ["note: comobj"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-ignoreSlave"),
    signalType: SignalTypes.Ignored,
    texts: ["slave"],
    dpts: undefined,
  },

  // shutter
  {
    id: ruleId("Button-Actions-shutter1"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["slats/stop", "slat adj"], //  ,SCN-RTN55S.01
    dpts: ["dpst-1-1", "dpst-1-7"], //  , BE-BZS86.01
  },
  {
    id: ruleId("Button-Actions-shutter2"),
    signalType: SignalTypes.SlatPosition,
    functionNames: ["position of slats", "slats open", "adjust", "slat position"],
    excludeFunctionNames: ["kelvin"],
    excludeTexts: ["kelvin"],
    dpts: ["dpst-5-1", "@ 1 byte"],
  },
  {
    id: ruleId("Button-Actions-merten-shutter2b"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["louvre"],
    dpts: ["dpst-1-8"],
    manufacturers: ["m-00e1"], // Lingg & Janke TA8F55-BCU-SEC
  },
  {
    id: ruleId("Button-Actions-shutter2a"),
    signalType: SignalTypes.SlatPosition,
    texts: ["position of slats", "slats open", "adjust", "slat position"],
    excludeFunctionNames: ["kelvin"],
    excludeTexts: ["kelvin"],
    dpts: ["dpst-5-1", "@ 1 byte"],
  },
  {
    id: ruleId("Button-Actions-shutter3"),
    signalType: SignalTypes.SlatPosition,
    functionNames: ["adjust"],
    excludeFunctionNames: ["value"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Button-Actions-shutter4"),
    signalType: SignalTypes.SlatPosition,
    texts: ["adjust"],
    excludeFunctionNames: ["value"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002"],
  },

  {
    id: ruleId("Button-Actions-shutter3_2"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["slats open", "lamella adj"], // , GH Q631 0074 R0111
    dpts: ["dpst-1-1", "dpst-1-9"], // , BE-GTL2Tx.01
  },
  {
    id: ruleId("Button-Actions-Elsner-shutter"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["short"],
    dpts: ["dpst-1-10"], //	Cala Touch KNX AQS/TH
    manufacturers: ["m-00c9"],
  },
  {
    id: ruleId("Button-Actions-Elsner-shutter2"),
    signalType: SignalTypes.BlindMove,
    texts: ["long"],
    dpts: ["dpst-1-8"], //	Cala Touch KNX AQS/TH
    manufacturers: ["m-00c9"],
  },

  //blind
  // {
  //   id: ruleId("Button-Actions-blind1"),
  //   signalType: SignalTypes.BlindDirectionValue,
  // ⚠ ONLY-HERE: nicht in Actor/Actions
  //   functionNames: ["direction"],
  //   dpts: ["dpst-1-8"],
  // },

  {
    id: ruleId("Button-Actions-blind8"),
    signalType: SignalTypes.BlindSingleObjectControl,
    functionNames: [/up.*down.*stop/],
    dpts: ["dpst-1-8"],
  },

  {
    id: ruleId("Button-Actions-blind2"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["up/down", "down/up", "up / down", "down / up", "change"],
    excludeFunctionNames: ["value for", "stop/step"], // MDT TAS 86xxxx
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Button-Actions-blind2a"),
    signalType: SignalTypes.BlindMove,
    texts: ["up/down", "down/up", "up / down", "down / up"],
    dpts: ["dpst-1-8"], //Lingg & Janke TA8F55-BCU-SEC
  },
  {
    id: ruleId("Button-Actions-blind2_2"),
    signalType: SignalTypes.BlindMove,
    texts: ["travel", "fahren", "up-down"], // 6108/01-500, 6125/01-500, 2TAZ730200R0010
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Button-Actions-blind2_3"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["travel"], //6320/58-..-500
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-blind3"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["stop", "shutter", "adjust"], // , , 6320/58-..-500
    excludeFunctionNames: ["setpoint", "current"],
    dpts: ["dpst-1-7", "dpst-1-1", "dpst-1-10"], //// . BE-TA55P6.01 ->Stop/Blinds Open/Close -- Stop/Blinds Open/Close	SwitchStatus		DPST-1-1
  },
  {
    id: ruleId("Button-Actions-blind3_2"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["adjust", "verstellen", "up-down"], //,6108/01-500,6125/01-500, 2TAZ730200R0010
    dpts: ["dpst-1-7"],
  },
  {
    id: ruleId("Button-Actions-blind3_3"),
    signalType: SignalTypes.BlindStopStep,
    texts: ["adjust"], //TB/U12.8
    dpts: ["dpst-1-8"],
  },

  {
    id: ruleId("Button-Actions-blind4"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["stop"],
    dpts: ["dpst-1-9", "dpst-1-8"], //  "dpst-1-8": Ingenium CT423220
  },
  {
    id: ruleId("Button-Actions-blind5"),
    signalType: SignalTypes.BlindPosition,
    functionNames: ["position", "height"],
    excludeFunctionNames: ["slat", "feedback", "status"],
    dpts: ["dpst-5-1"], // , GH Q631 0074 R0111 //// two different sizes (8 and 1 bytes)
  },
  {
    id: ruleId("Button-Actions-blind5_2"),
    signalType: SignalTypes.BlindPosition,
    functionNames: ["travel", "fahren"],
    dpts: ["dpst-5-1", "@ 1 byte"], // , 2CDG 006 320 R0014
  },
  {
    id: ruleId("Button-Actions-blind5a"),
    signalType: SignalTypes.BlindPosition,
    texts: ["travel", "fahren"],
    dpts: ["dpst-5-1", "@ 1 byte"], // , 2CDG 006 320 R0014
  },
   {
    id: ruleId("Button-Actions-blindb"),
    signalType: SignalTypes.BlindPosition,
    texts: [/shutter.*control/],
    dpts: ["dpst-5-1"], //Zennio Z35sdgfsdfsfdsdf
  },
  {
    id: ruleId("Button-Actions-blind6"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["long-time operation"],
    dpts: [
      "dpst-1 dpt-1", //jung 8471.02LEDW :)))
      "dpst-1-1", // jung 4071TSM
      "dpst-1-8", // jung 	5071TSM
    ],
  },
  {
    id: ruleId("Button-Actions-blind6_2"),
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["short-time operation", "short time operation"],
    dpts: [
      "dpst-1 dpt-1", //jung 8471.02LEDW :)))
      "dpst-1-1", // jung 4071TSM
      "dpst-1-7", // jung 52941ST
    ],
  },

  {
    id: ruleId("Button-Actions-blind7"),
    signalType: SignalTypes.BlindMove,
    functionNames: ["blind"],
    dpts: ["dpst-1-8"],
  },

  //Heating

  {
    id: ruleId("Button-Actions-selectMode1"),
    signalType: SignalTypes.OperationMode,
    excludeFunctionNames: ["travel", "status", "forced", "input"],
    excludeTexts: ["input"],
    dpts: ["dpst-20-102"],
  },

  {
    id: ruleId("Button-Actions-heater-opmode-forst"),
    signalType: SignalTypes.OperationMode_FrostProtection,
    functionNames: ["mode"],
    texts: ["frost"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-forst2"),
    signalType: SignalTypes.OperationMode_FrostProtection,
    texts: ["frost"], //ABB 6129/01-500
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-comfort"),
    signalType: SignalTypes.OperationMode_Comfort,
    functionNames: ["mode"],
    texts: ["comfort"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-comfort2"),
    signalType: SignalTypes.OperationMode_Comfort,
    texts: ["comfort"], //ABB 6129/01-500
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-night"),
    signalType: SignalTypes.OperationMode_Night,
    functionNames: ["mode"],
    texts: ["night"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-night2"),
    signalType: SignalTypes.OperationMode_Night,
    texts: ["night"], //ABB 6129/01-500
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-eco"),
    signalType: SignalTypes.OperationMode_Eco,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["mode"],
    texts: ["eco"],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater-opmode-eco2"),
    signalType: SignalTypes.OperationMode_Eco,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    texts: ["eco"], //ABB 6129/01-500
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Actions-heater2d"),
    signalType: SignalTypes.Temperature_ValveState,
    texts: [
      "heating control value", //	abb 6321/38-500,
    ],
    dpts: ["dpst-1-1"],
  },

  /////////////////////////////////////////////////////////////////////////////

  {
    id: ruleId("Button-Actions-heater1"),
    signalType: SignalTypes.Temperature_TargetShift_9,
    functionNames: ["setpoint shift", "reduction", "increase"],
    dpts: ["dpst-9-1", "dpst-9-2"], // mdt BE-TAS86Tx.02
  },
  {
    id: ruleId("Button-Actions-heater1a"),
    signalType: SignalTypes.Temperature_TargetShift_9,
    texts: ["output"],
    functionNames: ["setpoint adjustment"],
    dpts: ["dpst-9-2"], // lstouch
  },
  {
    id: ruleId("Button-Actions-heater1b"),
    signalType: SignalTypes.Temperature_TargetShift_6,
    texts: ["output"],
    functionNames: ["setpoint adjustment"],
    dpts: ["dpst-6-10"], // lstouch
  },

  {
    channelType: [ChannelType.Heating],
    id: ruleId("Button-Actions-heater1_2"),
    signalType: SignalTypes.Temperature_TargetShift_9,
    functionNames: ["change"],
    dpts: ["dpst-9-1", "dpst-9-2"], // mdt BE-TAS86Tx.02
  },
  // {
  //   id: ruleId("Button-Actions-heater1"),
  //   signalType: SignalTypes.Temperature_TargetStep_9,
  // ⚠ ONLY-HERE: nicht in Actor/Actions
  //   texts: ["actual set value"], //abb 6321/38-500
  //   dpts: ["dpst-9"],
  // },
  {
    id: ruleId("Button-Actions-heater1_4"),
    signalType: SignalTypes.Temperature_TargetStep_1,
    functionNames: ["setpoint", "increase"],
    dpts: ["dpst-1-7"],
  },
  {
    id: ruleId("Button-Actions-heater1_3"),
    signalType: SignalTypes.Temperature_TargetShift_6,
    excludeFunctionNames: ["status", "current", "input"],
    functionNames: ["setpoint", "reduction", "increase", "change"],
    excludeTexts: ["input"],
    dpts: ["dpst-6-10"], // mdt BE-TAS86Tx.02
  },
  {
    id: ruleId("Button-Actions-heater2"),
    signalType: SignalTypes.Ignored,
    texts: ["min"],
    excludeFunctionNames: ["dim"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-temp-ignore"),
    signalType: SignalTypes.Ignored,
    texts: [/temp.*scale/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Button-Actions-heater3"),
    signalType: SignalTypes.Ignored,
    texts: ["max"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater4"),
    signalType: SignalTypes.Temperature_MinMaxReset,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    texts: ["max/min", "min/max"],
    dpts: ["dpst-1-3"],
  },
  {
    id: ruleId("Button-Actions-heater6"),
    signalType: SignalTypes.Temperature_TargetComfort,
    functionNames: ["comfort setpoint"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater6_2"),
    signalType: SignalTypes.Temperature_TargetComfort,
    texts: ["setpoint comfort"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater7_c"),
    signalType: SignalTypes.Temperature_TargetComfort,
    texts: ["comfort"],
    functionNames: ["set setpoint", "send setpoint"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater7"),
    signalType: SignalTypes.Temperature_Target,
    excludeFunctionNames: ["status", "current", "input"],
    functionNames: [
      "setpoint",
      "value transmitter", // ls touch
    ],
    excludeTexts: ["input"],
    dpts: ["dpst-9-1"],
  },

  {
    id: ruleId("Button-Actions-heater7a"),
    signalType: SignalTypes.Temperature_Target,
    texts: ["setpoint"],
    excludeTexts: ["input"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater7b"),
    signalType: SignalTypes.Temperature_Target,
    excludeFunctionNames: ["status", "current", "input"],
    texts: [
      "actual set value", // abb 6321/38-500
    ],
    excludeTexts: ["input"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater7c"),
    signalType: SignalTypes.Temperature_Target,
    functionNames: ["temp"],
    texts: [/current setpoint adj/],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater7_2"),
    signalType: SignalTypes.Temperature_Target,
    texts: [
      "actual setpoint", //abb 	SBC/U10.0.1
      "setpoint temperature", // B.IQ
    ],
    dpts: [
      "dpst-9-1", //abb 	SBC/U10.0.1
      "@ 2 bytes", // B.IQ
    ],
  },

  {
    id: ruleId("Button-Actions-heater8"),
    signalType: SignalTypes.Temperature_TargetComfort,
    excludeFunctionNames: ["status", "actual", "input"],
    functionNames: ["setpoint comfort"],
    excludeTexts: ["input"],
    dpts: ["dpst-9-1"],
  },

  {
    id: ruleId("Button-Actions-heater9"),
    signalType: SignalTypes.Temperature_ControlValue,
    functionNames: ["control value"],
    excludeFunctionNames: ["status"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-heater9a"),
    signalType: SignalTypes.Temperature_ControlValue,
    texts: ["heating"],
    functionNames: ["continuous"],
    dpts: ["@ 1 byte"],
  },
  {
    id: ruleId("Button-Actions-heater10"),
    signalType: SignalTypes.Temperature_ValveState,
    functionNames: [
      "send control value",
      "pump on/off", //abb 2CDG 120 061 R0011????
    ],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Actions-heater11"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: undefined,
    excludeFunctionNames: ["input", "setpoint", "external", "adjust", "brightness"], // Externe Abgleichtemperature ABB TB/U4.4(.8)
    excludeTexts: ["input", "setpoint", "set", "external", "display", "brightness", "control", "indicator"], // "control", "indicator" z41 lite
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater12"),
    signalType: SignalTypes.Temperature_Target,
    texts: ["temperature control"], // "control", "indicator" z41 lite
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Button-Actions-heater13"),
    signalType: SignalTypes.Temperature_Current,
    functionNames: ["actual-temperature", "actual temperature"],
    excludeTexts: ["input"], // LS Touch
    dpts: ["dpst-9", "dpst-9-1"], //mdt BE-TAS86Tx.02
  },
  {
    id: ruleId("Button-Actions-heater14"),
    signalType: SignalTypes.Temperature_Current,
    texts: [/actual.temperatur/],
    dpts: ["dpst-9", "dpst-9-1", "@ 2 bytes"], //B.IQ
  },
  /////////////////////////////////////////////////////////////////////

  {
    id: ruleId("Button-Actions-selectMode3"),
    signalType: SignalTypes.OperationMode_Comfort,
    functionNames: ["comfort"],
    dpts: ["dpst-1-1"],
  },

  // RGBW
  {
    id: ruleId("Button-Actions-RGBW1"),
    signalType: SignalTypes.RGBValue6Byte,
    functionNames: ["rgbw"],
    dpts: ["dpst-251-600"],
  },
  {
    id: ruleId("Button-Actions-RGBW1"),
    signalType: SignalTypes.HSVValue,
    functionNames: ["hsv-value", "hsv value"], //BE-BZS86.01 -> no dpts-number availible
    dpts: undefined,
  },
  {
    id: ruleId("Button-Actions-RGBW2"),
    signalType: SignalTypes.RGBValue,
    functionNames: ["rgb"],
    dpts: ["dpst-232-600"],
  },
  {
    id: ruleId("Button-Actions-RGBW2_2"),
    signalType: SignalTypes.RGBValue,
    texts: ["rgb"],
    dpts: ["dpst-232-600"],
  },
  {
    id: ruleId("Button-Actions-RGBW3"),
    signalType: SignalTypes.RGBRedValue,
    functionNames: ["red dimming value", /red.*absolute/,"value red"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_1"),
    signalType: SignalTypes.RGBRedValue,
    texts: [/red/],
    functionNames: ["%"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_2"),
    signalType: SignalTypes.RGBRedValue,
    texts: ["colour red"],
    dpts: ["dpst-5-10"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_3"),
    signalType: SignalTypes.RGBGreenValue,
    texts: ["colour green"],
    dpts: ["dpst-5-10"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_1"),
    signalType: SignalTypes.RGBGreenValue,
    texts: [/green/],
    functionNames: ["%"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_4"),
    signalType: SignalTypes.RGBBlueValue,
    texts: ["colour blue"],
    dpts: ["dpst-5-10"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_1"),
    signalType: SignalTypes.RGBBlueValue,
    texts: [/blue/],
    functionNames: ["%"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW4"),
    signalType: SignalTypes.RGBGreenValue,
    functionNames: ["green dimming value", /green.*absolute/, "value green"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW5"),
    signalType: SignalTypes.RGBBlueValue,
    functionNames: ["blue dimming value", /blue.*absolute/, "value blue"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW6"),
    signalType: SignalTypes.RGBWhiteValue,
    functionNames: ["white dimming value", /white.*absolute/, "colour value white"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW3_1"),
    signalType: SignalTypes.RGBWhiteValue,
    texts: [/white/],
    functionNames: ["%"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-RGBW7"),
    signalType: SignalTypes.RGBRedStep,
    functionNames: [/red.*dimming relative/],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-RGBW8"),
    signalType: SignalTypes.RGBGreenStep,
    functionNames: [/green.*dimming relative/],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-RGBW9"),
    signalType: SignalTypes.RGBBlueStep,
    functionNames: [/blue.*dimming relative/],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-RGBW10"),
    signalType: SignalTypes.RGBWhiteStep,
    functionNames: [/white.*dimming relative/],
    dpts: ["dpst-3-7"],
  },

  /// Tuneable white
  {
    id: ruleId("Button-Actions-TunableWhite1"),
    signalType: SignalTypes.ColorTemperatureKelvin,
    excludeFunctionNames: ["status", "relative", "step"],
    dpts: ["dpst-7-600"], ///  Id="DPST-7-600" Number="600" Name="DPT_Absolute_Colour_Temperature" Text="absolute colour temperature (K)">
  },

  {
    id: ruleId("Button-Actions-TunableWhite3a"),
    signalType: SignalTypes.ColorTemperatureStep,
    functionNames: ["colour", "color"],
    dpts: ["dpst-3-7"], // DPT_Control_Dimming
  },

  {
    id: ruleId("Button-Actions-TunableWhite3b"),
    signalType: SignalTypes.ColorTemperatureKelvin,
    functionNames: ["colour", "color"],
    dpts: ["dpst-7-600"], // DPT_Absolute_Colour_Temperature
  },
  {
    id: ruleId("Button-Actions-TunableWhite4"),
    signalType: SignalTypes.ColorTemperatureStep,
    functionNames: ["color temperature relative"], //	BE-TAS5504.01
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-TunableWhite4a"),
    signalType: SignalTypes.ColorTemperaturePercent,
    functionNames: ["color temperature"], //	BE-TAS5504.01
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Button-Actions-TunableWhite5"),
    signalType: SignalTypes.TunableWhiteTransitionValue,
    functionNames: [/(color|colour) temp.*absolute/], //	BE-TAS5504.01
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-TunableWhite5_2"),
    signalType: SignalTypes.TunableWhiteTransitionValue,
    texts: [/(color|colour) temp.*value/], //	Cala Touch KNX AQS/TH 7082X
    dpts: ["dpst-5-1"],
  },

  // hsv rgb

  {
    id: ruleId("Button-Actions-Rgb1"),
    signalType: SignalTypes.HSV_HueStep,
    functionNames: ["hsv", "hue"],
    excludeFunctionNames: ["saturation"],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-Rgb1_2"),
    signalType: SignalTypes.HSV_HueValue,
    functionNames: [/hue.*absolute/],
    excludeFunctionNames: ["saturation"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Button-Actions-Rgb2"),
    signalType: SignalTypes.HSV_SaturationStep,
    functionNames: ["change hsv saturation", /saturation.*relative/], //BE-GT2Tx.02
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-Rgb2a"),
    signalType: SignalTypes.HSV_ColorValue,
    functionNames: ["hsv colour setting"],
    dpts: ["@ 3 bytes"],
  },
  {
    id: ruleId("Button-Actions-Rgb3"),
    signalType: SignalTypes.RGBValue6Byte,
    dpts: ["dpst-251-600"],
  },
  {
    id: ruleId("Button-Actions-TuneableWhite3"),
    signalType: SignalTypes.TunableWhiteBrightnessTransition249_600,
    dpts: ["dpst-249-600"], // MDT 	BE-GTSP6TX.01S
  },

  // TW
  {
    id: ruleId("Button-Actions-TW1"),
    signalType: SignalTypes.TWColdWhiteValue,
    functionNames: ["cold white brightness"],
    dpts: ["dpst-5-1"],
  },

  // dimmer
  {
    id: ruleId("Button-Actions-Dimmer1"),
    signalType: SignalTypes.DimStep,
    functionNames: undefined,
    excludeFunctionNames: ["absolute", "hsv", "hue", "saturation", "red", "green", "blue", "white"],
    dpts: ["dpst-3-7"],
  },
  {
    id: ruleId("Button-Actions-Dimmer1_2"),
    signalType: SignalTypes.DimStep,
    functionNames: ["dimming", "brighter/darker", "red", "green", "blue", "white"], //2CDG 006 320 R0014// jung 2076-2T //Theben
    dpts: ["dpst-3"],
  },
  {
    id: ruleId("Button-Actions-Dimmer2"),
    signalType: SignalTypes.DimStep,
    functionNames: ["dim"],
    excludeFunctionNames: ["on/off", "off/on"],
    dpts: ["dpst-3-7"],
  },

  {
    id: ruleId("Button-Actions-Dimmer5"),
    signalType: SignalTypes.DimStep,
    texts: ["dim"],
    dpts: ["@ 4 bit"],
  },

  {
    id: ruleId("Button-Actions-Dimmer3"),
    signalType: SignalTypes.DimValue,
    excludeFunctionNames: ["input"],
    excludeTexts: ["input"],
    functionNames: ["brightness", "dim", "decimal value"],
    dpts: ["dpst-5-1", "dpst-5-5"], ////
  },

  /// präsenzMelder
  {
    id: ruleId("Button-Actions-DimmerX"),
    signalType: SignalTypes.Brightness_Current,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    texts: ["brightness"], //ABB 	CGD 006 132 R0342 Präsenzmelder
    dpts: ["dpst-9-1"],
  },

  // switch 1
  {
    id: ruleId("Button-Actions-Switch1"),
    signalType: SignalTypes.SwitchInverted,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["invert"],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Actions-Ignored-1"),
    signalType: SignalTypes.Ignored,
    functionNames: [
      "request time", // JUNG Room controller display module 429D1ST
    ],
    dpts: ["dpst-1-1"],
  },

  {
    id: ruleId("Button-Actions-Switch2"),
    signalType: SignalTypes.Switch,
    functionNames: ["switch", "toggle", "schalten", "off", "on", "power", "=1", "=0", "request", "value"],
    excludeTexts: [
      "led", // led is "status-led" => status for MDT BE-xx
      "day/night", // "day/night" für MDT SCN-LCDGx.01
      "stop",
      "step",
      "move",
      "alarm",
    ],

    excludeFunctionNames: [
      "control",
      "value",
      "scene", // jung 4071TSM
    ], // led is "status-led" => status for MDT BE-xx
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9"],
  },

  {
    id: ruleId("Button-Actions-Jalouise-X3"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindStopStep,
    functionNames: ["kurzzeitbetrieb", "step"], // Berker 751448xx // GIRA 185 00
    excludeFunctionNames: [
      "control",
      "value",
      "switch",
      "scene", // jung 4071TSM
    ], // led is "status-led" => status for MDT BE-xx
    excludeTexts: ["switch"],
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9"],
  },

  {
    id: ruleId("Button-Actions-Jalouise-X3_1"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindStopStep,
    texts: [/drive.*short/],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Button-Actions-Jalouise-X3_2"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindMove,
    texts: [/drive.*long/],
    dpts: ["dpst-1-8"],
  },
  {
    id: ruleId("Button-Actions-Jalouise-X3_3"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindPosition,
    texts: [/drive.*position/],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Button-Actions-Jalouise-X4"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindMove,
    functionNames: ["langzeitbetrieb", "move"], // Berker 751448xx // GIRA 185 00
    excludeFunctionNames: [
      "control",
      "value",
      "scene", // jung 4071TSM
    ], // led is "status-led" => status for MDT BE-xx
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9"],
  },

  {
    id: ruleId("Button-Actions-Jalouise-X2"), // Merten MEG6214-41xx
    signalType: SignalTypes.BlindMove,
    texts: ["move"],
    excludeFunctionNames: [
      "control",
      "value",
      "scene", // jung 4071TSM
    ], // led is "status-led" => status for MDT BE-xx
    dpts: ["dpst-1-1", "dpst-1-8", "dpst-1-9"],
  },

  {
    id: ruleId("Button-Actions-Jalouise"),
    signalType: SignalTypes.BlindDirectionValue,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["direction"],
    dpts: ["dpst-1-8"],
  },

  {
    id: ruleId("Button-Actions-Environment4a"),
    signalType: SignalTypes.DayNight,
    functionNames: ["day", "night"],

    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-24"],
  },
  {
    id: ruleId("Button-Actions-Environment4b"),
    signalType: SignalTypes.DayNight,

    texts: ["day", "night"],
    dpts: ["dpst-1-1", "dpst-1-2", "dpst-1-24"],
  },

  {
    id: ruleId("Button-Actions-Switch3"),
    signalType: SignalTypes.Switch,
    functionNames: ["output", "input", "logic result"],
    excludeFunctionNames: ["output ", "input "], // blank no error but has to be
    dpts: ["dpst-1-1", "dpst-1-2"],
  },

  /// Time & Date
  {
    id: ruleId("Button-Actions-Time1"),
    signalType: SignalTypes.Time,
    functionNames: ["input", "time"],
    dpts: ["dpst-10-1"],
  },
  {
    id: ruleId("Button-Actions-Time2"),
    signalType: SignalTypes.TimeHrs55,
    functionNames: ["input", "time"],
    dpts: ["dpst-5-5"],
  },

  {
    id: ruleId("Button-Actions-Date1"),
    signalType: SignalTypes.Date,
    functionNames: ["input"],
    dpts: ["dpst-11-1"],
  },
  {
    id: ruleId("Button-Actions-DateTime1"),
    signalType: SignalTypes.DateTime,
    functionNames: ["input"],
    dpts: ["dpst-19-1"],
  },
  {
    id: ruleId("Button-Actions-DayNight1"),
    signalType: SignalTypes.DayNight,
    functionNames: ["day", "night"],
    dpts: ["dpst-1-2", "dpst-1-24"],
  },
  {
    id: ruleId("Button-Actions-DayNight2"),
    signalType: SignalTypes.DayNight,
    texts: ["night", "day"],
    dpts: ["dpst-1-2"],
  },

  // scene
  {
    id: ruleId("Button-Actions-Scene1"),
    signalType: SignalTypes.Scene,
    dpts: ["dpst-17-1", "dpst-18-1"],
  },
  {
    id: ruleId("Button-Actions-Scene2"),
    signalType: SignalTypes.Scene,
    functionNames: ["scene", "szene"],
    dpts: undefined,
  },

  // lock
  {
    id: ruleId("Button-Actions-Lock1"),
    signalType: SignalTypes.ButtonLock,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["lock", "block"], // //
    dpts: ["dpst-1-3"], //
  },
  {
    id: ruleId("Button-Actions-Lock2"),
    signalType: SignalTypes.ButtonLock,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["lock"], //jung 3904EBLED
    dpts: ["dpst-1-1"], //jung 3904EBLED
  },

  {
    id: ruleId("Button-Actions-ForcedConrol2"),
    signalType: SignalTypes.ForcedControl,
    functionNames: ["reset"],
    dpts: ["dspt-1-15"],
  },

  {
    id: ruleId("Button-Actions-WindowContact1"),
    // extra signal typ for window contact or where to include?
    signalType: SignalTypes.ButtonLock,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["window"], //JAL-0810M.02 AKH-0400.03
    dpts: ["dpst-1-2", "dpst-1-19"], //JAL-0810M.02 //AKH-0400.03
  },

  // Logic
  {
    id: ruleId("Button-Actions-Logic1"),
    signalType: SignalTypes.Switch,
    functionNames: ["output "],
    dpts: ["dpst-1-1", "dpst-1-11"],
  },
  {
    id: ruleId("Button-Actions-Logic2"),
    signalType: SignalTypes.Switch,
    texts: ["logic"],
    dpts: ["dpst-1-1", "dpst-1-2"], // // //ABB 6129/01-500
    // to catch all undefined signals on dpts 1-1,
  },
  {
    id: ruleId("Button-Actions-Switch5"),
    excludeFunctionNames: ["value", "enable", "indicator"], // BE-GTT4x.01 7// indicator = Z41 Lite
    excludeTexts: ["alarm", "indicator", "sequence"],
    signalType: SignalTypes.Switch,
    dpts: ["dpst-1-1"], //
  },

  // Forced Control 1
  {
    id: ruleId("Button-Actions-ForcedConrol1"),
    signalType: SignalTypes.ForcedControl,
    functionNames: ["control"],
    dpts: ["dpst-2-1"],
  },

  {
    id: ruleId("Button-Actions-ForcedSettings"),
    signalType: SignalTypes.Ignored,
    functionNames: ["send forced"], // mdt BE-TA55P2.01
    dpts: undefined,
  },

  {
    id: ruleId("Button-Actions-SendValue"),
    signalType: SignalTypes.Ignored,
    functionNames: ["send value"], // mdt BE-TA55P2.01
    dpts: undefined,
  },
  {
    id: ruleId("Button-Actions-SendValue-2"),
    signalType: SignalTypes.GenericValue,
    // ⚠ ONLY-HERE: nicht in Actor/Actions
    functionNames: ["value"], // Jung
    dpts: ["@ 1 byte"],
  },
  ////// scene default
  {
    id: ruleId("Button-Actions-SceneDefault1"),
    signalType: SignalTypes.Scene,
    functionNames: ["scene"],
    dpts: ["@ 1 byte", "dpst-17-1", "dpst-18-1"],
  },
  {
    id: ruleId("Button-Actions-SceneDefault2"),
    signalType: SignalTypes.Scene,
    texts: ["scene"],
    dpts: ["@ 1 byte", "dpst-17-1", "dpst-18-1"],
  },
];

export const buttonActionsSensitiv: Array<NameListEntry> = [
  {
    id: ruleId("Button-Actions-sensitiv-Heating1"),
    signalType: SignalTypes.Temperature_ControlValue,
    oldSignalType: SignalTypes.Unknown,
    functionNames: ["send control value"],
    dpts: ["dpst-5-1"],
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Button-Actions-sensitiv-Scene1"),
    signalType: SignalTypes.Scene,
    dpts: ["@ 1 byte"],
    channelType: [ChannelType.Scene],
  },

  {
    id: ruleId("Button-Actions-sensitiv-Dimm1"),
    signalType: SignalTypes.DimValue,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5"],
    channelType: [
      ChannelType.Dimmer,
      ChannelType.Switch, // to enable "upgade" from switch to dimmer for ets Import
    ],
  },

  {
    id: ruleId("Button-Actions-sensitiv-BlindMove"),
    signalType: SignalTypes.BlindMove,
    functionNames: [/long.*operation/],
    dpts: ["dpst-1"],
    channelType: [ChannelType.Jalousie, ChannelType.Blind],
  },
];
